// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__tG0eS"};